import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { QuoteSteps } from '../models/enums/quote-steps';
import { MotorQuoteStateService } from '../services/motor-quote-state/motor-quote-state.service';
import { QuoteFormMapService } from '../services/quote-retrieval/quote-form-map.service';

@Injectable({
    providedIn: 'root'
})
export class QuoteDetailsGuard {
    constructor(public router: Router,
        private readonly motorQuoteStateService: MotorQuoteStateService,
        private readonly quoteFormMapService: QuoteFormMapService) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const checkOnEditFlag = route.data['checkOnEditFlag'] as boolean;
        return this.isAllowedNavigate(checkOnEditFlag);
    }

    isAllowedNavigate(checkOnEditFlag: boolean): boolean {
        const invalidFormStep = this.quoteFormMapService.getInvalidFormStep();
        if (invalidFormStep === undefined) {
            if (this.motorQuoteStateService.getIsQuoteInEditMode() === false) {
                return true;
            } else if (checkOnEditFlag === true) {
                this.motorQuoteStateService.setStepState(QuoteSteps.getQuote);
                return false;
            } else {
                return true;
            }
        } else {
            this.motorQuoteStateService.setStepState(invalidFormStep);
            return false;
        }
    }

}